<script lang="ts">
	import type { IconName } from '$lib/components/icons/types.ts';
	import type { ClassValue } from 'svelte/elements';
	import type { AlertBoxColor } from './types';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';

	interface Props {
		color?: AlertBoxColor;
		icon?: IconName;
		title?: string;
		text: string;
		buttonIcon?: IconName;
		buttonText?: string ;
		contentClass?: ClassValue;
		onclick?: (event: Event) => void;
		class?: ClassValue;
	}

	const {
		color = 'white',
		icon,
		title,
		text,
		buttonIcon,
		buttonText,
		contentClass,
		onclick = () => {},
		class: classes,
	}: Props = $props();

	const colorClasses: Record<AlertBoxColor, string> = {
		white: 'bg-neutral-weakest border-neutral-soft',
		neutral: 'bg-neutral-weak border-neutral-soft',
		grey: 'bg-neutral-soft border-neutral-default',
		ev: 'bg-electric-weakest border-electric-weak',
		green: 'bg-success-weakest border-success-weak',
		amber: 'bg-warning-weakest border-warning-weak',
		red: 'bg-error-weakest border-error-weak',
	};
</script>

<div
	class={['flex gap-2 w-fit p-4 text-sm rd-4 border-1 border-solid', colorClasses[
		color
	], classes]}
>
	<div class={['alert-box-content flex-1', !icon && 'no-icon', !title && 'no-title', contentClass]}>
		{#if icon}
			<div class="alert-box-content-icon flex items-center justify-center">
				<Icon {icon} />
			</div>
		{/if}
		{#if title}
			<div class="alert-box-content-title text-bold">{title}</div>
		{/if}
		<div class="alert-box-content-text">{text}</div>
	</div>
	{#if buttonIcon || buttonText}
		<div class={['border-solid border-0.5', colorClasses[color]]}></div>
		<div class="flex items-center w-auto justify-center">
			<Button size="sm" variant="ghost" icon={buttonIcon} text={buttonText} {onclick} />
		</div>
	{/if}
</div>

<style>
	.alert-box-content {
		display: grid;
		gap: 8px;
		grid-template-areas: 'icon title' '. text';
		align-items: start;
		&.no-title {
			grid-template-areas: 'icon text';
		}

		&.no-icon {
			grid-template-areas: 'title' 'text';
			align-items: start;
			&.no-title {
				grid-template-areas: 'text';
				align-items: start;
			}
		}
	}
	.alert-box-content-title {
		grid-area: title;
	}

	.alert-box-content-text {
		grid-area: text;
	}

	.alert-box-content-icon {
		grid-area: icon;
	}

</style>
